import * as Sentry from "@sentry/react";
import i18next from "i18next";
import { useEffect, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";

import { useToasts } from "./components/app-shell/providers/toasts-provider/toasts-provider";
import { Text } from "./components/text";
import { initI18n } from "./i18n/init-i18n";

export const LanguageSettings: React.FC<{
  setI18NReady: (value: boolean) => void;
}> = ({ setI18NReady }: { setI18NReady: (value: boolean) => void }) => {
  const [searchParams] = useSearchParams();
  const potentialLanguagePreset = useMemo(
    () => searchParams.get("language"),
    [searchParams],
  );

  const [hasInitialized, setHasInitialized] = useState(false);

  const toasts = useToasts();
  useEffect(() => {
    if (!hasInitialized) {
      setHasInitialized(true);
      initI18n()
        .then(() => {
          if (potentialLanguagePreset) {
            i18next.changeLanguage(potentialLanguagePreset);
          }
          setI18NReady(true);
        })
        .catch((error) => {
          const label = "Error while initializing language selector";
          Sentry.captureException(error, {
            level: "error",
            extra: { label },
          });
          toasts.addToast({
            component: <Text text={label} />,
          });
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};
